import { render, staticRenderFns } from "./TenantsTable.vue?vue&type=template&id=49ffecfa&scoped=true"
import script from "./TenantsTable.vue?vue&type=script&lang=ts"
export * from "./TenantsTable.vue?vue&type=script&lang=ts"
import style0 from "./TenantsTable.vue?vue&type=style&index=0&id=49ffecfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ffecfa",
  null
  
)

export default component.exports